import moment from 'moment';

import i18n from 'src/config/i18n';

export const formatProgramWeekUnlockDate = (
    previousWeekCompletionDate: moment.Moment,
    unlockMessage: string,
): string | undefined => {
    const weekUnlockFormattedDate = moment(previousWeekCompletionDate)
        .add(7, 'days')
        .format(i18n.t('inputs.dateTime.dayOfMonthFormat'));

    return unlockMessage != ''
        ? `${unlockMessage} ${weekUnlockFormattedDate}.`
        : weekUnlockFormattedDate;
};
